import { MergeOrUpdateStateAction } from '@tableau/vizportalclient-common-components';
import React from 'react';
import _ from 'underscore';

import { Messages } from '../../../../codegen/Localize';
import { CheckboxState } from '../../../../common/components/checkboxes/CheckboxState';
import { openReactActionDialog } from '../../../../commonInfra/dialogs/ReactActionDialog';
import { TabDialogWidth } from '../../../../commonInfra/dialogs/style/TabDialogWidth';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';
import { Set } from '../../../../ts/models/Set';
import {
  IUpdateUsersGroupMembershipParams,
  IUpdateUsersGroupMembershipResult } from '../../../../ts/ServerApi/requests/UpdateUsersGroupMembershipRequest';
import { SiteUsers } from '../../../services/resources/SiteUsers';
import { ISiteUserInfo } from '../../../users/models/ISiteUserInfo';
import {
  EditGroupMembershipActionDialogProps,
  EditGroupMembershipDialog,
  EditGroupMembershipDialogProps,  EditGroupMembershipDialogState } from '../../components/EditGroupMembershipDialog';
import { GroupMembershipUpdateActionNotification } from '../notifications/GroupMembershipUpdateActionNotification';

export function isActionButtonEnabled(state: EditGroupMembershipDialogState): boolean {
  return !_.isEmpty(state.clientGroupsChanged);
}

export function showEditGroupMembershipDialog(users: Set<ISiteUserInfo>): Promise<IResult> {
  const title = Messages.groupMembership();
  const actionDisabled = (props: EditGroupMembershipDialogProps, state: EditGroupMembershipDialogState) => {
    return !isActionButtonEnabled(state);
  };

  const initialBodyProps: EditGroupMembershipDialogProps = {
    users: users
  };

  const initialDialogState: EditGroupMembershipDialogState = {
    awaitServerResponse: undefined,
    clientGroupsState: {},
    clientGroupsChanged: undefined,
    currentColumnSortOrder: undefined,
    groupsRendered: [],
    headerSelectionCheckboxState: undefined,
    searchText: undefined,
    showOnlyAssignedGroupCheckboxChecked: undefined,
  };

  const dialogInstance = openReactActionDialog<EditGroupMembershipDialogProps, EditGroupMembershipDialogState, IResult>({
    actionName: Messages.save(),
    action: assignGroupsMembership,
    actionDisabled,
    bodyComponent: EditGroupMembershipDialog,
    dialogWidth: TabDialogWidth.width700px,
    dismissDialogOnActionFailed: false,
    initialBodyProps,
    initialDialogState,
    title,
  });

  return Promise.resolve(dialogInstance.result);
}

async function assignGroupsMembership(
  props: EditGroupMembershipActionDialogProps,
  dialogState: EditGroupMembershipDialogState,
  updateDialogState: React.Dispatch<MergeOrUpdateStateAction<EditGroupMembershipDialogState>>): Promise<any> {
    const users = _.clone(props.users); // clone for independence from further selection
    const userIds = users.keys();

    const params: IUpdateUsersGroupMembershipParams = {
      userIds: userIds,
      addToGroupIds: [],
      removeFromGroupIds: []
    };

    // build up input params for the request: group IDs to add to & group IDs to remove from.
    _.each(dialogState.clientGroupsChanged, (clientGroupState, groupId) => {
      if (clientGroupState.groupCheckboxState === CheckboxState.checked) { params.addToGroupIds.push(groupId); }
      if (clientGroupState.groupCheckboxState === CheckboxState.empty) { params.removeFromGroupIds.push(groupId); }
    });

    if (isValidParamsForUpdate(params)) {
      // send the update to the server.
      return SiteUsers.instance.updateUsersGroupMembership(
        params.userIds,
        params.addToGroupIds,
        params.removeFromGroupIds
      ).then((result: IUpdateUsersGroupMembershipResult) => {

        let addedToGroupName = '';
        if(params.addToGroupIds.length > 0) {
          addedToGroupName = dialogState.clientGroupsChanged[params.addToGroupIds[0]].groupName;
        }

        let removedFromGroupName = '';
        if(params.removeFromGroupIds.length > 0) {
          removedFromGroupName = dialogState.clientGroupsChanged[params.removeFromGroupIds[0]].groupName;
        }

        // show toast
        GroupMembershipUpdateActionNotification.notify(
          result,
          users,
          params.addToGroupIds.length,
          addedToGroupName,
          params.removeFromGroupIds.length,
          removedFromGroupName);
      });
    }
}

function isValidParamsForUpdate(params: IUpdateUsersGroupMembershipParams): boolean {
  return (params.userIds.length > 0 && (params.addToGroupIds.length > 0 || params.removeFromGroupIds.length > 0));
}
